import { UserViewModel } from "../../viewmodels/setup/users/UserViewModel";

import { connect } from "react-redux";
import type { AnyAction } from "redux";
import type { ThunkDispatch } from "redux-thunk";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";
import MyAccountForm from "../../components/forms/my-account/MyAccountForm";
import MyPasswordForm from "../../components/forms/my-account/MyPasswordForm";

interface AccountDetailsPayload { name: string; email: string }
interface MyAccountProps {
  name: string;
  email: string;
  logout: () => void;
  updateAccountDetails: (payload: AccountDetailsPayload) => void;
}
interface AccountState { auth: { name: string; email: string } }
type AccountDispatch = ThunkDispatch<AccountState, unknown, AnyAction>;

function MyAccount(props: MyAccountProps) {
  const { email, logout, name, updateAccountDetails } = props;

  const { updateAccountPassword } = UserViewModel(logout);

  return (
    <div>
      <div>
        <MyAccountForm
          updateAccountDetails={updateAccountDetails}
          userDetails={{
            name: name,
            email: email,
          }}
        />
      </div>
      <div>
        <MyPasswordForm updateAccountPassword={updateAccountPassword} />
      </div>
    </div>
  );
}

const mapStateToProps = (state: AccountState) => {
  return {
    name: state.auth.name,
    email: state.auth.email,
  };
};
const mapDispatchToProps = (dispatch: AccountDispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    updateAccountDetails: (payload: AccountDetailsPayload) =>
      dispatch(actions.updateAccountDetails(payload)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyAccount));
